import ReactDom from "react-dom";

function Dropshadow(props) {
  const setDropShadow = () => {
    if (props.createOrUpdate === "Update") {
      props.onCancelHandler();
    }
    props.onDropDownToggle();
  };

  return ReactDom.createPortal(
    <div
      onClick={setDropShadow}
      className={`fixed inset-0 bg-textblack opacity-60 ${props.dropDownStyle}`}
    ></div>,
    document.querySelector("#backdrop")
  );
}

export default Dropshadow;
